import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgCodeSnippet01 = (props, ref) => (_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M16 18L22 12L16 6M8 6L2 12L8 18", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgCodeSnippet01);
export default ForwardRef;
